import React, { Component } from 'react';
import { storefrontApi, wishlistApi } from '../api/Api';
import { Link } from 'react-router-dom';
import { message } from 'antd';

import { isLogin } from '../utils/index';
import { addtocart, addwishlist, removewishlist } from '../utils/byoscart';

import ProductGallery from './utils/ProductGallery';
import './ProductDetailsSkeleton.css';
import './ProductDetailsTabs.css';
import PublicProductReviews from './utils/PublicProductReviews';

class Details extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu:[],
            productDetails:'',
            wishlistStatus:'',
            serviceCheck:false,
            quantity:1,
            selectedSkuId: '',
            selectedVariantOptions: {},
            useSelectedSkuMedia: false,
            isShortDescriptionOverflowing: false,
            shortDescriptionPreview: '',
            showShortDescriptionModal: false,
        }   
        this.shortDescriptionRef = React.createRef();
        this.loadingProductKey = '';
        this.updateShortDescriptionOverflow = this.updateShortDescriptionOverflow.bind(this);
    }

    async componentDidMount() {
        this.loadProductDetails();
        window.addEventListener('resize', this.updateShortDescriptionOverflow);
    }

    async componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.match.params.id !== this.props.match.params.id ||
            prevProps.match.params.name !== this.props.match.params.name ||
            prevProps.match.params.slug !== this.props.match.params.slug
        ) {
            window.scrollTo(0, 0);
            this.setState({
                serviceCheck: false,
                quantity: 1,
                selectedSkuId: '',
                selectedVariantOptions: {},
                useSelectedSkuMedia: false,
                isShortDescriptionOverflowing: false,
                shortDescriptionPreview: '',
                showShortDescriptionModal: false,
            });
            this.loadProductDetails();
        }

        const previousDescription = prevState.productDetails && prevState.productDetails.short_description;
        const currentDescription = this.state.productDetails && this.state.productDetails.short_description;
        if (previousDescription !== currentDescription) {
            this.updateShortDescriptionOverflow();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateShortDescriptionOverflow);
    }

    getProductSlug() {
        if (this.props.match.params.slug) {
            return decodeURIComponent(this.props.match.params.slug);
        }

        if (this.props.match.params.name) {
            return decodeURIComponent(this.props.match.params.name);
        }

        return 'apple-iphone-17-pro-max';
    }

    normalizeImages(media = {}) {
        const images = Array.isArray(media.images) ? media.images : [];
        const imageUrls = images.map((image) => image.url || image.image_url).filter(Boolean);

        if (media.primary_image_url && !imageUrls.includes(media.primary_image_url)) {
            imageUrls.unshift(media.primary_image_url);
        }

        return imageUrls;
    }

    getSelectedGalleryImages(product, selectedSku = {}, useSkuMedia = false) {
        const generalImages = this.normalizeImages(product.media || {});
        const skuImageGroups = Array.isArray(product.media && product.media.sku_images)
            ? product.media.sku_images
            : [];
        const allSkuImages = skuImageGroups
            .flatMap((item) => this.normalizeImages(item || {}));
        return [...generalImages, ...allSkuImages.filter((image) => !generalImages.includes(image))];
    }

    getSelectedPreviewImage(selectedSku = {}, useSkuMedia = false) {
        if (!useSkuMedia) {
            return '';
        }

        const skuImages = this.normalizeImages(selectedSku.media || {});
        return skuImages[0] || '';
    }

    getSelectedSku(product, selectedSkuId = '') {
        const skus = Array.isArray(product.skus) ? product.skus : [];
        return skus.find((sku) => String(sku.id) === String(selectedSkuId)) ||
            skus.find((sku) => sku.is_default) ||
            product.default_sku ||
            {};
    }

    isProductInStock(product = this.state.productDetails) {
        return Boolean(product && product.inventory && product.inventory.in_stock === true);
    }

    normalizeProductDetails(product, selectedSkuId = this.state.selectedSkuId, useSkuMedia = this.state.useSelectedSkuMedia) {
        const selectedSku = this.getSelectedSku(product, selectedSkuId);
        const pricing = selectedSku.pricing || product.pricing || {};
        const offer = selectedSku.offer || pricing.offer || product.offer || {};
        const inventory = selectedSku.inventory || product.inventory || {};
        const categoryPath = product.category_path || {};
        const currency = pricing.currency_symbol || '₹';
        const hasOffer = Boolean(offer.has_offer);
        const mrpPrice = pricing.mrp || selectedSku.mrp || product.mrp || '';
        const finalPrice = hasOffer
            ? (pricing.offer_price || offer.offer_price || pricing.selling_price)
            : pricing.selling_price;
        const effectiveDiscountPercent = Number(mrpPrice || 0) > Number(finalPrice || 0)
            ? ((Number(mrpPrice) - Number(finalPrice)) / Number(mrpPrice)) * 100
            : 0;

        return {
            ...product,
            product_id: product.id,
            variation_id: selectedSku.id || (product.default_sku && product.default_sku.id) || product.id,
            product_name: product.name || product.product_name || '',
            brand: (categoryPath.department && categoryPath.department.name) || product.brand || 'Nature Way',
            sub_category: (categoryPath.category && categoryPath.category.name) || '',
            final_category: (categoryPath.final_category && categoryPath.final_category.name) || '',
            display_image_all: this.getSelectedGalleryImages(product, selectedSku, useSkuMedia),
            offer,
            offer_price: finalPrice,
            selling_price: mrpPrice,
            mrp: mrpPrice,
            currency_symbol: currency,
            discount_percent: effectiveDiscountPercent,
            tax_inclusive: pricing.tax_inclusive,
            inventory,
            short_description: product.short_description || '',
            long_description: product.description || product.short_description || 'Product details will be updated soon.',
            specification: Array.isArray(product.specifications) ? product.specifications : [],
            highlights: Array.isArray(product.highlights) ? product.highlights : [],
            variant_groups: Array.isArray(product.variant_groups) ? product.variant_groups : [],
            skus: Array.isArray(product.skus) ? product.skus : [],
            selected_sku: selectedSku,
            selected_preview_image: this.getSelectedPreviewImage(selectedSku, useSkuMedia),
            wishlist: product.wishlist || 'No',
        };
    }

    sanitizeDescriptionHtml(html = '') {
        if (!html) return '';

        if (typeof window === 'undefined' || !window.DOMParser) {
            return String(html);
        }

        const parser = new window.DOMParser();
        const doc = parser.parseFromString(String(html), 'text/html');
        doc.querySelectorAll('script, style, link, meta, base, iframe, object, embed').forEach((node) => node.remove());

        doc.body.querySelectorAll('*').forEach((node) => {
            Array.from(node.attributes).forEach((attribute) => {
                const name = attribute.name.toLowerCase();
                const value = attribute.value.trim().toLowerCase();

                if (name.startsWith('on') || ((name === 'href' || name === 'src') && value.startsWith(`java${'script'}:`))) {
                    node.removeAttribute(attribute.name);
                }
            });
        });

        return doc.body.innerHTML;
    }

    getVariantSelectionForSku(product, skuId) {
        const selectedOptions = {};
        const variantGroups = Array.isArray(product.variant_groups) ? product.variant_groups : [];

        variantGroups.forEach((group) => {
            const option = (group.options || []).find((item) => {
                const skuIds = Array.isArray(item.sku_ids) ? item.sku_ids.map(String) : [];
                return skuIds.includes(String(skuId));
            });

            if (option) {
                selectedOptions[group.id || group.name] = option.id || option.value || option.name;
            }
        });

        return selectedOptions;
    }

    getSkuForVariantSelection(product, selectedOptions) {
        const variantGroups = Array.isArray(product.variant_groups) ? product.variant_groups : [];
        const skus = Array.isArray(product.skus) ? product.skus : [];
        const selectedSkuGroups = variantGroups
            .map((group) => {
                const selectedOptionId = selectedOptions[group.id || group.name];
                return (group.options || []).find((option) => String(option.id || option.value || option.name) === String(selectedOptionId));
            })
            .filter(Boolean);

        if (selectedSkuGroups.length === 0) {
            return this.getSelectedSku(product);
        }

        return skus.find((sku) => selectedSkuGroups.every((option) => {
            const skuIds = Array.isArray(option.sku_ids) ? option.sku_ids.map(String) : [];
            return skuIds.includes(String(sku.id));
        })) || {};
    }

    async loadProductDetails() {

        /* scroll to top of the page */
        window.scrollTo(0, 0);
        const productSlug = this.getProductSlug();
        const countryId = localStorage.getItem('country_id') || '';
        const productKey = `${productSlug}:${countryId}`;

        if (this.loadingProductKey === productKey) {
            return;
        }

        this.loadingProductKey = productKey;

        try {
            const response = await storefrontApi.getProductDetail(productSlug, countryId);
             let resVal=response.data;
              if(resVal.success===true || resVal.status==='success'){
                  const normalizedProduct = this.normalizeProductDetails(resVal.data || {}, '', false);
                  this.setState({
                      productDetails: normalizedProduct,
                      selectedSkuId: normalizedProduct.variation_id,
                      selectedVariantOptions: this.getVariantSelectionForSku(normalizedProduct, normalizedProduct.variation_id),
                      useSelectedSkuMedia: false,
                      serviceCheck:true,
                      wishlistStatus: normalizedProduct.wishlist,
                  }, () => this.updateShortDescriptionOverflow());
                  if (isLogin()) {
                      wishlistApi.list({ optional: true }).then((wishlistResponse) => {
                          const saved = wishlistResponse.data?.data || [];
                          const skuId = normalizedProduct.variation_id;
                          this.setState({ wishlistStatus: saved.some((item) => String(item.product_sku_id) === String(skuId)) ? 'Yes' : 'No' });
                      }).catch(() => {});
                  }
              }
              this.setState({serviceCheck:true});
          } catch (error) {
              this.setState({serviceCheck:true});
            console.error(error);
          } finally {
              if (this.loadingProductKey === productKey) {
                  this.loadingProductKey = '';
              }
          }

         

        //   const script = document.createElement("script");
        //   script.async = true;
        //   script.src = "/assets/js/main.js";
        //   document.body.appendChild(script);

    }

    getVariantLabel(variant) {
        return (variant && (variant.value || variant.name || variant.sku)) || 'Variant';
    }

    selectSku(skuId) {
        const product = this.state.productDetails || {};
        const selectedSku = this.getSelectedSku(product, skuId);
        this.setState({
            selectedSkuId: selectedSku.id || skuId,
            useSelectedSkuMedia: true,
            productDetails: this.normalizeProductDetails(product, selectedSku.id || skuId, true),
            selectedVariantOptions: this.getVariantSelectionForSku(product, selectedSku.id || skuId),
        });
    }

    selectVariantOption(group, option) {
        const product = this.state.productDetails || {};
        const optionKey = option.id || option.value || option.name;
        const nextSelectedOptions = {
            ...this.state.selectedVariantOptions,
            [group.id || group.name]: optionKey,
        };
        const selectedSku = this.getSkuForVariantSelection(product, nextSelectedOptions);

        this.setState({
            selectedVariantOptions: nextSelectedOptions,
            selectedSkuId: selectedSku.id || this.state.selectedSkuId,
            useSelectedSkuMedia: true,
            productDetails: selectedSku.id ? this.normalizeProductDetails(product, selectedSku.id, true) : product,
        });
    }

    loadVariantOptions() {
        const variantGroups = Array.isArray(this.state.productDetails.variant_groups) ? this.state.productDetails.variant_groups : [];

        if (variantGroups.length === 0) {
            return null;
        }

        return (
            <div className="ps-product__variants">
                {variantGroups.map((group) => (
                    <div className="ps-product__variant-stack" key={group.id || group.name}>
                        <h6>{group.name || 'Options'}</h6>
                        <div className="ps-product__variant-list">
                            {(group.options || []).map((option) => {
                                const optionKey = option.id || option.value || option.name;
                                const isActive = String(this.state.selectedVariantOptions[group.id || group.name]) === String(optionKey);
                                const optionSkuIds = Array.isArray(option.sku_ids) ? option.sku_ids.map(String) : [];
                                const hasSku = optionSkuIds.length > 0;
                                const hasInStockSku = (this.state.productDetails.skus || []).some((sku) => optionSkuIds.includes(String(sku.id)) && sku.inventory && sku.inventory.in_stock);

                                return (
                                    <button
                                        type="button"
                                        key={option.id || option.value}
                                        onClick={() => hasSku ? this.selectVariantOption(group, option) : null}
                                        className={`ps-product__variant ${isActive ? 'ps-product__variant--active' : ''} ${hasSku && !hasInStockSku ? 'ps-product__variant--out' : ''}`}
                                        title={option.name || option.value}
                                        disabled={!hasSku}
                                    >
                                        {this.getVariantLabel(option)}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}

            </div>
        );
    }

    updateShortDescriptionOverflow() {
        const element = this.shortDescriptionRef.current;
        if (!element) return;

        const fullDescription = this.state.productDetails.short_description || '';
        const computedStyle = window.getComputedStyle(element);
        const maxHeight = parseFloat(computedStyle.lineHeight) * 4;
        const measurer = document.createElement('p');
        measurer.className = element.className;
        measurer.style.position = 'absolute';
        measurer.style.visibility = 'hidden';
        measurer.style.pointerEvents = 'none';
        measurer.style.left = '-9999px';
        measurer.style.top = '0';
        measurer.style.width = `${element.clientWidth}px`;
        measurer.style.margin = '0';
        document.body.appendChild(measurer);
        measurer.textContent = fullDescription;

        if (measurer.scrollHeight <= maxHeight + 1) {
            document.body.removeChild(measurer);
            if (this.state.isShortDescriptionOverflowing || this.state.shortDescriptionPreview !== fullDescription) {
                this.setState({
                    isShortDescriptionOverflowing: false,
                    shortDescriptionPreview: fullDescription,
                });
            }
            return;
        }

        let low = 0;
        let high = fullDescription.length;
        let preview = '';

        while (low <= high) {
            const mid = Math.floor((low + high) / 2);
            const candidate = `${fullDescription.slice(0, mid).trimEnd()}... More`;
            measurer.textContent = candidate;

            if (measurer.scrollHeight <= maxHeight + 1) {
                preview = candidate;
                low = mid + 1;
            } else {
                high = mid - 1;
            }
        }

        if (!preview) {
            preview = '... More';
        }

        document.body.removeChild(measurer);

        if (!this.state.isShortDescriptionOverflowing || this.state.shortDescriptionPreview !== preview) {
            this.setState({
                isShortDescriptionOverflowing: true,
                shortDescriptionPreview: preview,
            });
        }
    }

    renderShortDescription() {
        const description = this.state.productDetails.short_description;
        if (!description) return null;

        return (
            <div className="ps-product__short-description-wrap">
                <p className="ps-product__short-description" ref={this.shortDescriptionRef}>
                    {this.state.isShortDescriptionOverflowing ? (
                        <>
                            {this.state.shortDescriptionPreview.replace('... More', '')}
                            <button
                                type="button"
                                className="ps-product__short-description-more"
                                onClick={() => this.setState({ showShortDescriptionModal: true })}
                            >
                                ... More
                            </button>
                        </>
                    ) : description}
                </p>
                {this.state.isShortDescriptionOverflowing ? (
                    null
                ) : null}
            </div>
        );
    }

    renderShortDescriptionModal() {
        if (!this.state.showShortDescriptionModal) return null;

        return (
            <div className="ps-product__short-description-modal" role="dialog" aria-modal="true" aria-labelledby="short-description-title">
                <button
                    type="button"
                    className="ps-product__short-description-backdrop"
                    aria-label="Close short description"
                    onClick={() => this.setState({ showShortDescriptionModal: false })}
                />
                <div className="ps-product__short-description-dialog">
                    <div className="ps-product__short-description-dialog-head">
                        <h3 id="short-description-title">Product Description</h3>
                        <button
                            type="button"
                            className="ps-product__short-description-close"
                            aria-label="Close"
                            onClick={() => this.setState({ showShortDescriptionModal: false })}
                        >
                            <i className="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                    <p>{this.state.productDetails.short_description}</p>
                </div>
            </div>
        );
    }


    loginNotification(){
        message.error({
            content: 'Login to continue',
            className: 'notificationBox',
        });
    }

    wishlistLoginNotification(){
        this.props.history.push({ pathname: '/signin', state: {
            from: this.props.location,
        } });
    }

    localaddcart(){
        if (!this.isProductInStock()) {
            message.error({
                content: 'This product is currently out of stock.',
                className: 'notificationBox',
            });
            return;
        }

        this.setState({cartStatus:'Yes'});
        addtocart(this.state.productDetails.product_id, this.state.selectedSkuId || this.state.productDetails.variation_id, this.state.quantity);
    }

    increaseQuantity(){
        this.setState((prevState) => ({
            quantity: prevState.quantity + 1,
        }));
    }

    decreaseQuantity(){
        this.setState((prevState) => ({
            quantity: prevState.quantity > 1 ? prevState.quantity - 1 : 1,
        }));
    }

    handleQuantityChange(event){
        const nextValue = parseInt(event.target.value, 10);

        this.setState({
            quantity: Number.isNaN(nextValue) || nextValue < 1 ? 1 : nextValue,
        });
    }

    localremovewishlist(){
        if (!isLogin()) {
            this.wishlistLoginNotification();
            return;
        }

        this.setState({wishlistStatus:'No'});
        removewishlist(this.state.productDetails.variation_id);
    }

    localaddwishlist(){
        if (!isLogin()) {
            this.wishlistLoginNotification();
            return;
        }

        this.setState({wishlistStatus:'Yes'});
        addwishlist(this.state.productDetails.variation_id);
    }

    loadWishlist(){
        if(this.state.wishlistStatus=='Yes'){
            return(
                <div className="ps-product__item wishlistActive detailPageButton" data-toggle="tooltip" data-placement="left" title="Wishlist"><a onClick={()=>this.localremovewishlist(this.state.productDetails.variation_id)}><i className="fa fa-heart-o"></i></a></div>
            )
        }else{
            return(
                <div className="ps-product__item detailPageButton" data-toggle="tooltip" data-placement="left" title="Wishlist"><a onClick={()=>this.localaddwishlist(this.state.productDetails.variation_id)}><i className="fa fa-heart-o"></i></a></div>
            )   
        }
    }

    loadImageSlider(){
        return(
            <>
                <ProductGallery
                    galleryList={this.state.productDetails.display_image_all}
                    activeImageUrl={this.state.productDetails.selected_preview_image}
                    {...this.props}
                />
            </>
        )
    }

    renderDetailLoader() {
        return (
            <div className="ps-page--product ps-product-detail-skeleton" role="status" aria-busy="true" aria-label="Loading product details">
                <div className="container whiteContainer" aria-hidden="true">
                    <div className="ps-detail-skeleton__breadcrumb" aria-hidden="true">
                        <span></span><span></span><span></span><span className="ps-detail-skeleton__breadcrumb--long"></span>
                    </div>
                    <div className="ps-page__content">
                        <div className="ps-detail-skeleton__layout">
                            <div className="ps-detail-skeleton__gallery">
                                <div className="ps-detail-skeleton__image"></div>
                                <div className="ps-detail-skeleton__thumbs">
                                    <span className="ps-detail-skeleton__thumb-arrow"></span>
                                    <span></span><span></span><span></span>
                                    <span className="ps-detail-skeleton__thumb-arrow"></span>
                                </div>
                            </div>
                            <div className="ps-detail-skeleton__info">
                                <div className="ps-detail-skeleton__topline">
                                    <div className="ps-detail-skeleton__brand-group">
                                        <span className="ps-detail-skeleton__brand"></span>
                                        <span className="ps-detail-skeleton__brand ps-detail-skeleton__badge"></span>
                                    </div>
                                    <span className="ps-detail-skeleton__rating"></span>
                                </div>
                                <span className="ps-detail-skeleton__title"></span>
                                <span className="ps-detail-skeleton__title ps-detail-skeleton__title--short"></span>
                                <span className="ps-detail-skeleton__line ps-detail-skeleton__line--wide"></span>
                                <span className="ps-detail-skeleton__line ps-detail-skeleton__line--medium"></span>
                                <div className="ps-detail-skeleton__price-row">
                                    <span className="ps-detail-skeleton__price"></span>
                                    <span className="ps-detail-skeleton__line ps-detail-skeleton__mrp"></span>
                                    <span className="ps-detail-skeleton__brand ps-detail-skeleton__offer"></span>
                                </div>
                                <span className="ps-detail-skeleton__line ps-detail-skeleton__tax"></span>
                                <div className="ps-detail-skeleton__variant"></div>
                                <div className="ps-detail-skeleton__actions">
                                    <span className="ps-detail-skeleton__quantity"></span>
                                    <span className="ps-detail-skeleton__cart"></span>
                                    <span className="ps-detail-skeleton__heart"></span>
                                </div>
                                <div className="ps-detail-skeleton__services">
                                    <span></span><span></span><span></span>
                                </div>
                            </div>
                        </div>
                        <div className="ps-detail-skeleton__highlights">
                            {[0, 1, 2, 3, 4].map((item) => <span className="ps-detail-skeleton__variant" key={item}></span>)}
                        </div>
                        <div className="ps-detail-skeleton__tabs">
                            <span className="ps-detail-skeleton__brand"></span>
                            <span className="ps-detail-skeleton__brand"></span>
                            <span className="ps-detail-skeleton__brand"></span>
                        </div>
                        <span className="ps-detail-skeleton__line ps-detail-skeleton__line--wide"></span>
                        <span className="ps-detail-skeleton__line ps-detail-skeleton__line--medium"></span>
                    </div>
                </div>
            </div>
        );
    }


    handleReviewSummary = summary => this.setState(previous => ({productDetails:{...previous.productDetails, average_rating:summary.average_rating, review_count:summary.review_count}}));

    render() {

        if(this.state.serviceCheck===false) {
            return this.renderDetailLoader();
        }
        const { productDetails } = this.state;
        const highlights = Array.isArray(productDetails.highlights) ? productDetails.highlights : [];
        const specifications = Array.isArray(productDetails.specification) ? productDetails.specification : [];
        const ratingValue = Math.min(5, Math.max(0, Number(productDetails.average_rating) || 0));
        const reviewCount = Math.max(0, Number(productDetails.review_count) || 0);
        const isInStock = this.isProductInStock(productDetails);
        const badges = Array.isArray(productDetails.badges) ? productDetails.badges : [];
        const productBadge = badges.find((badge) => badge && (badge.name || badge.title || badge.label));
        const badgeLabel = productBadge ? (productBadge.name || productBadge.title || productBadge.label)
            : (productDetails.badge_name || productDetails.badge || productDetails.product_badge);
        const discountPercent = Number(productDetails.offer_price) > 0 && Number(productDetails.mrp) > Number(productDetails.offer_price)
            ? Math.round((1 - Number(productDetails.offer_price) / Number(productDetails.mrp)) * 100) : 0;
        const detailHighlights = [
            { icon: 'fa-tint', title: 'Rich in', subtitle: 'Omega-6 & MUFA' },
            { icon: 'fa-heart-o', title: 'Helps Lower', subtitle: 'Cholesterol' },
            { icon: 'fa-leaf', title: 'Contains Natural', subtitle: 'Antioxidants' },
            { icon: 'fa-leaf', title: 'Traditionally', subtitle: 'Wood Pressed' },
            { icon: 'fa-flask', title: 'No Chemicals', subtitle: 'or Additives' },
        ];
        const serviceHighlights = [
            { icon: 'fa-truck', title: 'Free Delivery', subtitle: 'On orders above $50' },
            { icon: 'fa-shield', title: 'Secure Payment', subtitle: '100% secure checkout' },
            { icon: 'fa-refresh', title: 'Easy Returns', subtitle: '7 days return policy' },
        ];
        return (
            <>
                <div class="ps-page--product">
                        <div class="container whiteContainer">
                            <ul class="ps-breadcrumb">
                                <li class="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                                <li class="ps-breadcrumb__item"><Link to="/">{productDetails.sub_category}</Link></li>
                                <li class="ps-breadcrumb__item"><Link to="/">{productDetails.final_category}</Link></li>
                                <li class="ps-breadcrumb__item active" aria-current="page">{productDetails.product_name}</li>
                            </ul>
                            <div class="ps-page__content">
                                <div class="ps-product--detail">
                                    <div class="row">
                                        <div class="col-12 col-md-12">
                                            <div class="row">
                                                <div className="col-12 col-xl-6 ps-details-gallery-column">


                                                    {this.loadImageSlider()}


                                                </div>
                                                <div className="col-12 col-xl-6 ps-details-info-column">
                                                        <div class="ps-product__info">
                                                            <div className="ps-product__branch-row">
                                                                <div className="ps-details-brand-badges">
                                                                <div class="ps-product__branch">
                                                                    <i className="fa fa-leaf" aria-hidden="true"></i>
                                                                    <a>{productDetails.brand}</a>
                                                                </div>
                                                                {typeof badgeLabel === 'string' && badgeLabel ? <span className="ps-details-product-badge">{badgeLabel}</span> : null}
                                                                </div>
                                                                <div class="ps-product__rating ps-product__rating--title" aria-label={`${ratingValue} out of 5 stars, ${reviewCount} ${reviewCount===1?'review':'reviews'}`}>
                                                                    <span class="ps-product__rating-stars" aria-hidden="true">




                                                                        {[1,2,3,4,5].map(star=><span key={star} className="rattingsStar ps-product__rating-star">
                                                                            <i className="fa fa-star-o"/>
                                                                            <span className="ps-product__rating-fill" style={{width:`${Math.round(Math.min(1,Math.max(0,ratingValue-star+1))*100)}%`}}><i className="fa fa-star"/></span>
                                                                        </span>)}
                                                                    </span>
                                                                    <span class="ps-product__rating-score">{ratingValue.toFixed(1)}</span>
                                                                    <span class="ps-product__review">({reviewCount} {reviewCount===1?'review':'reviews'})</span>
                                                                </div>
                                                            </div>
                                                        <h1 className="ps-product__title">{productDetails.product_name}</h1>
                                                        <div class="ps-product__purchase">
                                                            {this.renderShortDescription()}

                                                            <div class="ps-product__meta">
                                                                <span class="ps-product__price">{productDetails.currency_symbol || '₹'}{productDetails.offer_price}</span>
                                                                {Number(productDetails.mrp || 0) > Number(productDetails.offer_price || 0) ? <span class="ps-product__del">{productDetails.currency_symbol || '₹'}{productDetails.mrp}</span> : null}
                                                                {discountPercent > 0 ? <span className="ps-details-price-offer">{discountPercent}% OFF</span> : null}
                                                                <span className="ps-product__tax-note">Inclusive of all taxes</span>
                                                            </div>

                                                            {productDetails.offer?.state==='conditional' && <p className="nw-review-note"><strong>{productDetails.offer.offer_badge}</strong> · {productDetails.offer.terms}</p>}
                                                            {this.loadVariantOptions()}

                                                            <div className="ps-product__action-row">
                                                                <div className="ps-product__quantity ps-product__quantity--inline">
                                                                    <h6>Quantity</h6>
                                                                    <div className="def-number-input number-input safari_only">
                                                                        <button type="button" className="minus" aria-label="Decrease quantity" onClick={()=>this.decreaseQuantity()}><i className="icon-minus"></i></button>
                                                                        <input className="quantity" aria-label="Quantity" min="1" name="quantity" value={this.state.quantity} type="number" onChange={(event)=>this.handleQuantityChange(event)} />
                                                                        <button type="button" className="plus" aria-label="Increase quantity" onClick={()=>this.increaseQuantity()}><i className="icon-plus"></i></button>
                                                                    </div>
                                                                </div>

                                                                <button
                                                                    type="button"
                                                                    className={`ps-btn ps-btn--warning hand ps-product__action-cart ${!isInStock ? 'ps-product__action-cart--disabled' : ''}`}
                                                                    onClick={() => isInStock ? this.localaddcart() : null}
                                                                    disabled={!isInStock}
                                                                    aria-disabled={!isInStock}
                                                                >
                                                                    {isInStock ? 'Add to cart' : 'Out of stock'}
                                                                </button>

                                                                <div className="ps-product__action-links">
                                                                    {this.loadWishlist()}
                                                                </div>
                                                            </div>

                                                            <div className="ps-product__service-row" aria-label="Delivery and payment benefits">
                                                                {serviceHighlights.map((item) => (
                                                                    <div className="ps-product__service-item" key={item.title}>
                                                                        <i className={`fa ps-product__service-icon ${item.icon}`} aria-hidden="true"></i>
                                                                        <div className="ps-product__service-copy">
                                                                            <strong>{item.title}</strong>
                                                                            <span>{item.subtitle}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                           
                                                        </div>
                                                        {highlights.length>0?
                                                        <div class="ps-product__desc">
                                                            <ul class="ps-product__list">
                                                            { highlights.map((highlightsItem)=>{
                                                                return(
                                                                        <li key={String(highlightsItem)}>{typeof highlightsItem === 'string' ? highlightsItem : highlightsItem.highlights}</li>
                                                                    )
                                                                })
                                                            }
                                                            </ul>
                                                        </div>
                                                        : null }
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ps-product__highlight-strip" aria-label="Product highlights">
                                        {detailHighlights.map((item) => (
                                            <div className="ps-product__highlight-item" key={`${item.title}-${item.subtitle}`}>
                                                <i className={`fa ${item.icon}`} aria-hidden="true"></i>
                                                <div className="ps-product__highlight-copy">
                                                    <strong>{item.title}</strong>
                                                    <span>{item.subtitle}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="ps-product__content nw-product-tabs">
                                        <ul class="nav nav-tabs ps-tab-list" id="productContentTabs" role="tablist">
                                            <li className="nav-item" role="presentation"><a className="nav-link active" id="description-tab" data-toggle="tab" href="#description-content" role="tab" aria-controls="description-content" aria-selected="true"><i className="fa fa-align-left" aria-hidden="true" />Description</a></li>
                                            <li className="nav-item" role="presentation"><a className="nav-link" id="specification-tab" data-toggle="tab" href="#specification-content" role="tab" aria-controls="specification-content" aria-selected="false"><i className="fa fa-list-ul" aria-hidden="true" />Specification</a></li>
                                            <li className="nav-item" role="presentation"><a className="nav-link" id="reviews-tab" data-toggle="tab" href="#reviews-content" role="tab" aria-controls="reviews-content" aria-selected="false"><i className="fa fa-star-o" aria-hidden="true" />Reviews <span className="nw-product-tabs__count">{reviewCount}</span></a></li>
                                        </ul>
                                        <div class="tab-content" id="productContent" >
                                            <div class="tab-pane fade show active" id="description-content" role="tabpanel" aria-labelledby="description-tab">
                                                <h3 className="nw-product-tabs__heading">About this product</h3>
                                                <div class="ps-document mb-20">
                                                    
                                                    {/* <p class="ps-desc">{productDetails.short_description}</p> */}

                                                    <div
                                                        className="ps-desc ps-product__description-html"
                                                        dangerouslySetInnerHTML={{ __html: this.sanitizeDescriptionHtml(productDetails.long_description || productDetails.short_description || 'Product description is not available yet.') }}
                                                    />
                                                    
                                                </div>
                                            </div>
                                            <div class="tab-pane fade" id="specification-content" role="tabpanel" aria-labelledby="specification-tab">
                                                <h3 className="nw-product-tabs__heading">Product specifications</h3>
                                                {!specifications.length && <p className="nw-product-tabs__muted">Specifications are not available for this product yet.</p>}
                                                { specifications.map((specificationDetails)=>{
                                                    return(
                                                            <div className="nw-product-tabs__spec-group" key={specificationDetails.id || specificationDetails.name}>
                                                            <div class="ps-table__name">{specificationDetails.specification_group_name || specificationDetails.name}</div>

                                                            <table class="table ps-table ps-table--oriented">
                                                            <tbody>
                                                            { (specificationDetails.specification_items || specificationDetails.items || []).map((specificationItem)=>{
                                                                return(
                                                                    <tr key={specificationItem.id || specificationItem.name}>
                                                                        <th className="ps-table__th" scope="row">{specificationItem.specificationitem_name || specificationItem.name}</th>
                                                                        <td>{specificationItem.specification || specificationItem.value}{specificationItem.unit ? ` ${specificationItem.unit}` : ''}</td>
                                                                    </tr>
                                                                    )
                                                                })
                                                            }
                                                                </tbody>
                                                            </table>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                
                                            </div>
                                            <div class="tab-pane fade" id="reviews-content" role="tabpanel" aria-labelledby="reviews-tab">

                                                <PublicProductReviews slug={productDetails.slug} productId={productDetails.product_id} onSummary={this.handleReviewSummary}/>

                                                {/* <div class="ps-product__tabreview">
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Mark J.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>Everything is perfect. I would recommend!</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review2.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Ann R.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>There was a small mistake in the order. In return, I got the correct order and I could keep the wrong one for myself.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review3.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Jenna S.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>I ordered on Friday evening and on Monday at 12:30 the package was with me. I have never encountered such a fast order processing.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review4.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">John M.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>Everything is perfect. I would recommend!</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Mark J.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>There was a small mistake in the order. In return I got the correct order and I could keep the wrong one for myself.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                {/* <div class="ps-form--review">
                                                    <div class="ps-form__title">Write a review</div>
                                                    <div class="ps-form__desc">Your email address will not be published. Required fields are marked *</div>
                                                    <form action="http://nouthemes.net/html/mymedi/do_action" method="post">
                                                        <div class="row">
                                                            <div class="col-12 col-lg-4">
                                                                <label class="ps-form__label">Your rating *</label>
                                                                <select class="ps-rating--form" data-value="0">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-6 col-lg-4">
                                                                <label class="ps-form__label">Name *</label>
                                                                <input class="form-control ps-form__input"/>
                                                            </div>
                                                            <div class="col-6 col-lg-4">
                                                                <label class="ps-form__label">Email *</label>
                                                                <input class="form-control ps-form__input"/>
                                                            </div>
                                                            <div class="col-12">
                                                                <div class="ps-form__block">
                                                                    <label class="ps-form__label">Your review *</label>
                                                                    <textarea class="form-control ps-form__textarea"></textarea>
                                                                </div>
                                                            </div>
                                                            <div class="col-12 text-center">
                                                                <button class="btn ps-btn ps-btn--warning">Add Review</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                {this.renderShortDescriptionModal()}
            </>
        );
    }
}

export default Details;
